import React from "react";
import { Facebook, Instagram, Phone, Mail } from "lucide-react";
import { site, navLinks } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#1d1c1a] text-[#f2ece1]">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <svg width="40" height="40" viewBox="0 0 48 48" fill="none">
              <path d="M6 6h16a0 0 0 0 1 0 0v14a10 10 0 0 1-10 10H6a0 0 0 0 1 0 0V6Z" fill="#ff5a58" />
              <path d="M24 12a12 12 0 0 1 12 12 12 12 0 0 1-12 12V12Z" fill="#86233a" />
            </svg>
            <div>
              <p className="font-display text-xl">{site.name}</p>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#ffd7d4]">{site.role}</p>
            </div>
          </div>
          <p className="mt-5 text-[#f2ece1]/70 max-w-xs leading-relaxed">
            Jouw persoonlijk reisadviseur. Ik maak je droomreis op maat:
            persoonlijk, professioneel en volledig zorgeloos.
          </p>
          <div className="mt-6 flex gap-3">
            <a href={site.socials.facebook} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-[#86233a] transition-colors">
              <Facebook size={17} />
            </a>
            <a href={site.socials.instagram} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-[#86233a] transition-colors">
              <Instagram size={17} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg">Navigatie</h4>
          <ul className="mt-5 space-y-3">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-[#f2ece1]/70 hover:text-[#ff5a58] transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg">Contact</h4>
          <ul className="mt-5 space-y-3 text-[#f2ece1]/70">
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#ff5a58]" /> {site.phone}
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#ff5a58]" />
              <span className="break-all">{site.email}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[#f2ece1]/50">
          <p>© {new Date().getFullYear()} {site.name}, Travel Counsellor. Alle rechten voorbehouden.</p>
          <p>Gemaakt voor onvergetelijke reizen</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
